export const getDeleteDialogData = state => state.app.deleteDialog;
export const getFillTemplateDialogData = state => state.app.fillTemplateDialog;
export const getFilePreviewDialogData = state => state.app.filePreviewDialog;
export const getManagerDrawerData = state => state.app.managerDrawer;
export const getLocationDrawerData = state => state.app.locationDrawer;
export const getClinicianDrawerData = state => state.app.clinicianDrawer;
export const getSixthFlowPromptsDrawerData = state => state.app.sixthFlowPromptsDrawer;
export const getSuperbillGoalDrawerData = state => state.app.superbillGoalDrawer;
export const getEsignFlowDrawerData = state => state.app.esignFlowDrawer;
export const getAbortControllerData = state => state.app.abortController;